import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const MicrophoneIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M7.5 14.6667V12.6667C7.5 12.3905 7.72386 12.1667 8 12.1667C8.27614 12.1667 8.5 12.3905 8.5 12.6667V14.6667C8.5 14.9428 8.27614 15.1667 8 15.1667C7.72386 15.1667 7.5 14.9428 7.5 14.6667Z"
      fill="currentColor"
    />
    <path
      d="M2.83333 7.99969V6.66669C2.83333 6.39054 3.05719 6.16669 3.33333 6.16669C3.60947 6.16669 3.83333 6.39054 3.83333 6.66669V7.99969C3.83333 9.10476 4.27263 10.1646 5.05404 10.946C5.83544 11.7274 6.89526 12.1667 8.00032 12.1667C9.10528 12.1666 10.1653 11.7273 10.9466 10.946C11.7278 10.1646 12.1663 9.10461 12.1663 7.99969V6.66669C12.1663 6.39065 12.3903 6.16686 12.6663 6.16669C12.9425 6.16669 13.1663 6.39054 13.1663 6.66669V7.99969C13.1663 9.36983 12.6224 10.6841 11.6536 11.653C10.6848 12.6219 9.37049 13.1666 8.00032 13.1667C6.63004 13.1667 5.31594 12.622 4.347 11.653C3.37807 10.6841 2.83333 9.36998 2.83333 7.99969Z"
      fill="currentColor"
    />
    <path
      d="M9.5 3.33331C9.5 2.50489 8.82843 1.83331 8 1.83331C7.17157 1.83331 6.5 2.50489 6.5 3.33331V8.00031C6.50018 8.82858 7.17168 9.50031 8 9.50031C8.82832 9.50031 9.49982 8.82858 9.5 8.00031V3.33331ZM10.5 8.00031C10.4998 9.38087 9.3806 10.5003 8 10.5003C6.6194 10.5003 5.50018 9.38087 5.5 8.00031V3.33331C5.5 1.9526 6.61929 0.833313 8 0.833313C9.38071 0.833313 10.5 1.9526 10.5 3.33331V8.00031Z"
      fill="currentColor"
    />
  </svg>
);
